import React from "react";
import {
  withStyles,
  Drawer,
  Button,
  Divider,
  Grid,
  TextField,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { groupBy, flatMap,size } from "lodash/collection";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { observer, inject } from "mobx-react";
import { DropdownEditor, DateTimeEditor } from "../../../../dataGrid/cellEditors";
import appConstant from "../../../../../appConstants";
import styles from "./styles";
import Feedback from "./Feedback";
import { convertDateTimeToTimeString, isTimeValid } from "../../../../dataGrid/gridUtilities";
import { ShipmentList, ShipmentProperties } from "./sharedComponents";
import { postData } from "../../../../../api/componentAPIs";
import MESSAGES from "../../../../../appMessages";
import Events from "../../../../../utilities/EventEmitter";
import { MapConstant } from "../../../../../lib/Map";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";
import { withAppConfig } from "../../../../../appConfigContext";
import {
  Default_Shipment_Properties,
  getShipmentProperties,
} from "./utils";

@inject('IBPlanningStore')
@observer
class LassoRoute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            routeCreationComplete: false,
            routeCreationInProgress: false,
            routeCreationDetails: {},
            selectedShipments: Default_Shipment_Properties,
            routeShipments: Default_Shipment_Properties,
            routeStatus: 0,
            comment: "",
            routeType: appConstant.ROUTE_TYPES.CITY,
            routeName: null,
            startTime: null,
            trailerName: null,
            trailerId: null,
            anchorPointName: null,
            isTrapRoute: false,
            wasTrapRoute: false,
            errors: null,
            shipmentsToExclude: [],
            selectedShipmentsToExclude: [],
            disableTrapField: false,
            isNewRoute: false
        }
        this.startTimeRef = React.createRef();
        this.routeNameRef = React.createRef();
        this.disableRouteShipmentsUpdate = false;
        this._isMounted = false;
        this.selectedRoutesBeforeLasso = [];
    }

    componentDidMount() {
        //    this.props.IBPlanningStore.setIsLassoActiveWithShipments(true);
        //    this.props.IBPlanningStore.setIsLassoRouteCreated(false);
        this.props.glEventHub.emit("setIsLassoActiveWithShipments", true);
        this.props.glEventHub.emit("UpdateIBStore", "setIsLassoRouteCreated", [false]);
        this.updateShipments({ shipments: this.props.shipments, shipmentTypes: "selectedShipments" });
        this.selectedShipmentRoutes = this.getShipmentRoutes();

        // Need to focus on first input after loading
        setTimeout(() => {
            this.routeNameRef.focusInput();
        }, 0);
        this._isMounted = true;
        this.props.glEventHub.on(appConstant.Event.CLOSE_LASSO_PANEL, this.props.onClose);
    }

    componentWillUnmount() {
        this._isMounted = false;
        //this.props.IBPlanningStore.setIsLassoActiveWithShipments(false);
        //this.props.IBPlanningStore.setIsLassoRouteCreated(false);
        this.props.glEventHub.emit("UpdateIBStore", "setIsLassoRouteCreated", [false]);
        this.props.glEventHub.emit("setIsLassoActiveWithShipments", false);
        Events.emit(MapConstant.EVENT.SET_MAP_DRAW, { eventType: "clearDraw" });
        this.props.glEventHub.off(appConstant.Event.CLOSE_LASSO_PANEL, this.props.onClose);
    }

    componentDidUpdate(prevProps) {
        if (this.props.shipments !== prevProps.shipments) {
            const selectedShipmentsToExclude = this.props.isNewLasso ? [] : this.state.selectedShipmentsToExclude;
            let selectedShipments = this.filterSelectedShipments(this.state.routeName, selectedShipmentsToExclude);

            //this.props.IBPlanningStore.setIsLassoActiveWithShipments(true);
            this.updateShipments({
                shipments: selectedShipments,
                shipmentType: "selectedShipments"
            });
            if (this.props.isNewLasso) {
                this.selectedShipmentRoutes = this.getShipmentRoutes();
                //this.props.IBPlanningStore.setIsLassoRouteCreated(false);
                this.props.glEventHub.emit("UpdateIBStore", "setIsLassoRouteCreated", [false]);
                this.state.routeCreationComplete && this.routeNameRef.clearValue();
                this.setState({
                    routeCreationComplete: false,
                    selectedShipmentsToExclude: [],
                    shipmentsToExclude: []
                });
            }
            this.routeNameRef.focusInput();
        }
    }

    getShipmentRoutes = () => {
        return [...new Set(this.props.shipments.map(shipment => shipment.routeName))];
    }

    updateShipments = ({ shipments = [], shipmentType }) => {
        const properties = {
            hu: 0,
            priority: 0,
            specialNeeds: 0,
            totalProps: shipments.length,
            totalWeight: 0,
            pse: 0,
            totalStops: 0,
        }
        shipments.forEach(s => {
            properties.hu += s.hu || 0,
                properties.priority += s.priority ? 1 : 0,
                properties.specialNeeds += s.specialNeeds ? 1 : 0,
                properties.totalWeight += s.weight || 0,
                properties.pse += s.pse || 0
        });
        const groupedShipmentPerCustomer = groupBy(shipments, shipment => {
            if (shipment.isDelivery) {
              return shipment.customerId;
            }
            return shipment.rmaxShipperCode;
          })
        this.setState({
            [shipmentType]: {
                shipments: groupedShipmentPerCustomer,
                ...properties,
                totalStops: size(groupedShipmentPerCustomer),
            }
        }, () =>
            //this.props.IBPlanningStore.updateSelectedShipments(this.getShipmentsForLassoRoute())
            this.props.glEventHub.emit("UpdateIBStore", "updateSelectedShipments", [this.getShipmentsForLassoRoute()])
        );
    }

    onStatusChange = (event, status) => {
        if (status !== null) {
            this.setState({
                routeStatus: status
            });
        }
    }

    updateComment = (event) => {
        this.setState({
            comment: event.target.value
        });
    }
    updateStartTime = (startTime) => {
        if (startTime === null) {
            this.setState({
                startTime
            })
        } else if (this.startTimeRef) {
            const timeString = convertDateTimeToTimeString(this.startTimeRef.getValue());
            if (isTimeValid(timeString)) {
                this.setState({
                    startTime: timeString
                });
            }
        }
    }

    updateTrailer = (trailer) => {
        const { label, value } = trailer || { label: null, value: null };
        this.setState({
            trailerName: label,
            trailerId: value
        });
    }

    updateAnchorPoint = (anchorPoint) => {
        const { label } = anchorPoint || { label: null };
        this.setState({
            anchorPointName: label,
        });
    }

    updateTrapStatus = (event, routeType) => {
        const isTrapRoute = routeType === appConstant.ROUTE_TYPES.TRAP;
        this.setState({
            routeType,
            isTrapRoute,
            routeStatus: isTrapRoute ? appConstant.routeLockStates.LOCK.value : appConstant.routeLockStates.UNLOCK.value
        });
    }

    routeNameChanged = (route) => {
        if (this.disableRouteShipmentsUpdate && route) {
            // this helps to avoid multiple rerenders when user does undo after routecreation
            if (route.label && route.label === this.state.routeName) {
                return;
            }
            this.disableRouteShipmentsUpdate = false;
        }

        // if routeName changed clear excluded shipments
        const shipmentsToExclude = route && route.label === this.state.routeName ? this.state.shipmentsToExclude : [];
        // update both new and existing shipments for this route and update value for route properties
        let routeShipments = route ?
            this.props.IBPlanningStore.plannedShipmentsList.filter(shipment => shipment.routeName === route.label && !shipmentsToExclude.includes(shipment.proId))
            : [];
        this.updateShipments({
            shipments: routeShipments,
            shipmentType: "routeShipments"
        });

        // Filter and update new shipments not present in selected route
        this.updateShipments({
            shipments: this.filterSelectedShipments(route ? route.label : null, this.state.selectedShipmentsToExclude),
            shipmentType: "selectedShipments"
        });

        //dont select newRoute when it is created
        if (!(route && route.isNewValue)) {
            this.selectRoutes(route && route.label);
        }

        const { routeName, startTime, trailerName, trailerId, status, comment, isTrapRoute, anchorPointName } = route && !route.isNewValue ?
            this.props.IBPlanningStore.routesList.find(r => r.routeName === route.label)
            : { routeName: null, startTime: null, trailerName: null, trailerId: null, status: 0, comment: "", isTrapRoute: false, anchorPointName: null }
        this.setState({
            startTime,
            trailerName,
            trailerId,
            comment: comment || "",
            routeStatus: status,
            routeName,
            isTrapRoute,
            routeType: isTrapRoute ? appConstant.ROUTE_TYPES.TRAP : appConstant.ROUTE_TYPES.CITY,
            wasTrapRoute: isTrapRoute,
            anchorPointName,
            disableTrapField: appConstant.APPOINTMENT_ROUTES.includes(routeName),
            shipmentsToExclude
        });
        this.updateError(null);
    }

    filterSelectedShipments = (selectedRouteName, shipmentsToExclude) => {
        return this.props.shipments.filter(shipment => shipment.routeName !== selectedRouteName && !shipmentsToExclude.includes(shipment.proId));
    }

    selectRoutes = (newRoute) => {
        // if old route (present in state) has shipment belonging to lasso while lasso creation don't deselect the route
        let selectedRoutes = this.props.IBPlanningStore.selectedRouteNameList;
        if (!this.selectedShipmentRoutes.includes(this.state.routeName)) {
            selectedRoutes = selectedRoutes.filter(route => route !== this.state.routeName);
        }
        newRoute && selectedRoutes.push(newRoute);
        //this.props.IBPlanningStore.updateSelectedRoutes(selectedRoutes);
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedRoutes", [selectedRoutes])
    }

    createLassoRoute = (event) => {
        event.preventDefault();
        if (!this.isInputValid()) {
            return;
        }

        const { trailerId, routeStatus, startTime, comment, shipmentsToExclude, isTrapRoute, anchorPointName } = this.state;
        const route = this.routeNameRef.getValue();
        this.setState({
            routeCreationInProgress: true,
            isNewRoute: route.isNewValue
        });
        const requestObj = {
            scenarioId: this.props.scenarioId,
            routeName: route.label,
            shipments: this.getShipmentsForLassoRoute(),
            trailerId,
            routeStatus,
            startTime,
            comment,
            isTrapRoute,
            shipmentsToExclude,
            anchorPointName
        }
        this.selectedRoutesBeforeLasso = this.props.IBPlanningStore.selectedRouteNameList.slice();
        postData('CreateRoute', requestObj).then(response => {
            if (response && Math.trunc(response.status/100) === 2) {
                if (this._isMounted) {
                    this.setState({
                        routeCreationDetails: {
                            scenarioId: this.props.scenarioId,
                            ...response.data,
                        },
                        routeCreationInProgress: false,
                        routeCreationComplete: true
                    });
                }
                this.disableRouteShipmentsUpdate = true;
                this.refeshDataStore([requestObj.routeName]);
                //this.props.IBPlanningStore.setIsLassoRouteCreated(true);
                this.props.glEventHub.emit("UpdateIBStore", "setIsLassoRouteCreated", [true]);
            } else {
                if (this._isMounted) {
                    this.setState({
                        routeCreationInProgress: false
                    });
                }
                this.props.enqueueSnackbar(MESSAGES.LASSO.ROUTE_CREATION_FAILED, { variant: "error" });
            }
        }, error => {
            if (this._isMounted) {
                this.setState({
                    routeCreationInProgress: false
                });
            }
            this.props.enqueueSnackbar(MESSAGES.LASSO.ROUTE_CREATION_FAILED, { variant: "error" });
        });

        trackEvent(`${this.props.currentView}Lasso`, this.props.userProfile, { isNewRoute: route.isNewValue });
    }
    isInputValid = () => {
        if (this.routeNameRef.getValue()) {
            return true;
        } else {
            this.updateError({ routeName: 'Route Name is required' });
            this.routeNameRef.focusInput();
        }
    }

    updateError = (error) => {
        this.setState({
            error
        });
    }
    onDeleteShipment = (shipmentField, customerID) => {
        const filteredShipment = this.state[shipmentField];
        const shipmentsToExclude = filteredShipment.shipments[customerID].map(shipment => shipment.proId);
        if (shipmentField === 'routeShipments') {
            this.setState(state => ({
                shipmentsToExclude: [...state.shipmentsToExclude, ...shipmentsToExclude]
            }));
        } else {
            this.setState(state => ({
                selectedShipmentsToExclude: [...state.selectedShipmentsToExclude, ...shipmentsToExclude]
            }));
        }
        delete filteredShipment.shipments[customerID];
        this.updateShipments({
            shipments: flatMap(filteredShipment.shipments),
            shipmentType: shipmentField
        });
    }

    refeshDataStore = (lassoRouteNames) => {
        const selectedRoutes = [...new Set([...this.props.IBPlanningStore.selectedRouteNameList, ...lassoRouteNames])];
        //Events.emit("RefreshIBStore", false, selectedRoutes, this.getShipmentsForLassoRoute());
        this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [false, selectedRoutes, this.getShipmentsForLassoRoute()]);
    }

    getShipmentsForLassoRoute = () => {
        const { selectedShipments, routeShipments } = this.state;
        const allShipments = [...flatMap(selectedShipments.shipments).map(shipment => shipment.proId),
        ...flatMap(routeShipments.shipments).map(shipment => shipment.proId)];
        return allShipments;
    }

    undoLasso = () => {
        this.refeshDataStore(this.selectedRoutesBeforeLasso);
        this.props.glEventHub.emit("UpdateIBStore", "setIsLassoRouteCreated", [false]);
        if (this._isMounted) {
            this.setState({
                routeCreationComplete: false
            });
        }
    }

    render() {
        const { classes } = this.props;
        const container = this.props.container;
        const {
            routeShipments,
            selectedShipments,
            routeStatus,
            startTime,
            trailerId,
            error,
            routeCreationInProgress,
            comment,
            routeType,
            isTrapRoute,
            wasTrapRoute,
            anchorPointName,
            disableTrapField, isNewRoute } = this.state;
        const hasShipments = Object.keys(this.state.selectedShipments.shipments).length + Object.keys(this.state.routeShipments.shipments).length;
        return (
            <Drawer
                ModalProps={container ? { container } : {}}
                variant="persistent"
                anchor="right"
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    modal: classes.modal
                }}
                BackdropProps={{
                    className: classes.backdrop,
                    hideBackdrop: true
                }}
            >
                {
                    <React.Fragment>
                        <div className={this.state.routeCreationComplete ? classes.hideContent : classes.showContent}>
                            <Divider className={classes.divider} />
                            <Grid item xs={12} className={classes.head}>
                                Route Assignment
                            </Grid>
                            <Divider className={classes.divider} />
                            <form onSubmit={this.createLassoRoute}>
                                <div className={`${classes.data} customScroll`}>
                                    <div className={classes.group}>
                                        <div>Selected Shipments</div>
                                        <ShipmentList
                                            customerShipments={selectedShipments.shipments}
                                            onDeleteShipment={(customerID) => this.onDeleteShipment("selectedShipments", customerID)}
                                        />
                                        <ShipmentProperties data={getShipmentProperties(selectedShipments)} />
                                    </div>
                                    <Divider className={classes.divider} />
                                    <div className={classes.group}>
                                        <div>
                                            <Grid container spacing={16}>
                                                <Grid item xs={4} classes={{ item: classes.editorContainerLabel }}>Route Name <span className={classes.errorColor}>*</span></Grid>
                                                <Grid item xs={8} classes={{ item: classes.editorContainer }}>
                                                    <DropdownEditor
                                                        column={{
                                                            colDef: {
                                                                field: "routeName",
                                                                cellEditorParams: {
                                                                    canAcceptNewValue: true,
                                      ...this.props.configJSON.routeNameEditParams,
                                                                    noNullValue: true,
                                                                },
                                                            },
                                                        }}
                                                        onChange={this.routeNameChanged}
                                                        ref={ref => this.routeNameRef = ref}
                                                    />
                                                    {error && error.routeName && (<div className={classes.errorColor}>{error.routeName}</div>)}
                                                </Grid>
                                                <Grid item xs={4}>Route Type</Grid>
                                                <Grid item xs={8}>
                                                    <FormControl component="fieldset" disabled={disableTrapField} >
                                                        <RadioGroup
                                                            aria-label="Route type"
                                                            name="routeType"
                                                            value={routeType}
                                                            onChange={this.updateTrapStatus}
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                value={appConstant.ROUTE_TYPES.CITY}
                                                                control={<Radio color="primary" classes={{ root: classes.radio, disabled: classes.radioDisabled }} />}
                                                                label="City"
                                                                classes={{ label: classes.radioLabel, disabled: classes.radioDisabled }}
                                                            />
                                                            <FormControlLabel
                                                                value={appConstant.ROUTE_TYPES.TRAP}
                                                                control={<Radio color="primary" classes={{ root: classes.radio, disabled: classes.radioDisabled }} />}
                                                                label="Trap"
                                                                classes={{ label: classes.radioLabel, disabled: classes.radioDisabled }}
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>

                                                {wasTrapRoute && wasTrapRoute !== isTrapRoute && (
                                                    <Grid item xs={12} >
                                                        <div className={classes.trapRouteWarning}>
                                                            Changing trap route to city route. Are you sure you want to do this change?
                                                            </div>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </div>
                                        <div className={classes.paddingTop}>Existing Shipments</div>
                                        <ShipmentList
                                            customerShipments={routeShipments.shipments}
                                            onDeleteShipment={(customerID) => this.onDeleteShipment("routeShipments", customerID)}
                                        />
                                        <ShipmentProperties data={getShipmentProperties(routeShipments)} />
                                    </div>
                                    <Divider className={classes.divider} />
                                    <div className={classes.group}>
                                        <Grid container spacing={16}>
                                            <Grid item xs={4} classes={{ item: classes.editorContainerLabel }}>Start Time</Grid>
                                            <Grid item xs={8} classes={{ item: classes.editorContainerTime }}>
                                                <DateTimeEditor
                                                    dateType={appConstant.DATETYPES.TIME}
                                                    ref={ref => this.startTimeRef = ref}
                                                    value={startTime}
                                                    onChange={this.updateStartTime}
                                                    disableFocus
                                                    enablePickerPortal
                                                />
                                            </Grid>
                                            <Grid item xs={4} classes={{ item: classes.editorContainerLabel }}>Trailer Type</Grid>
                                            <Grid item xs={8} classes={{ item: classes.editorContainer }}>
                                                <DropdownEditor
                                                    column={{ colDef: { field: "trailerName" } }}
                                                    value={trailerId}
                                                    onChange={this.updateTrailer}
                                                />
                                            </Grid>
                                            <Grid item xs={4} classes={{ item: classes.editorContainerLabel }}>Anchor Point</Grid>
                                            <Grid item xs={8} classes={{ item: classes.editorContainer }}>
                                                <DropdownEditor
                                                    column={{ colDef: { field: "anchorPointName" } }}
                                                    value={anchorPointName}
                                                    onChange={this.updateAnchorPoint}
                                                />
                                            </Grid>
                                            <Grid item xs={4} classes={{ item: classes.statusLabel }}>Status</Grid>
                                            <Grid item xs={8}>
                                                <ToggleButtonGroup
                                                    exclusive
                                                    selected
                                                    value={routeStatus}
                                                    onChange={this.onStatusChange}
                                                    classes={{ root: classes.toggleGroup }}
                                                >
                                                    {
                                                        Object.values(appConstant.routeLockStates).map(lockStatus => (
                                                            <ToggleButton
                                                                value={lockStatus.value}
                                                                key={lockStatus.text}
                                                                classes={{
                                                                    root: classes.toggleButton,
                                                                    selected: classes.toggleButtonSelected
                                                                }}>
                                                                <div>
                                                                    <i className={`${lockStatus.icon} ${classes.statusIcon}`} />
                                                                    <div className={classes.lockStateText}>{lockStatus.text}</div>
                                                                </div>
                                                            </ToggleButton>

                                                        ))
                                                    }
                                                </ToggleButtonGroup>
                                            </Grid>
                                            <Grid item xs={4}>Comments</Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    value={comment}
                                                    multiline
                                                    rows={3}
                                                    variant="outlined"
                                                    onChange={this.updateComment}
                                                    classes={{
                                                        root: classes.formControl
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.comments,
                                                            notchedOutline: classes.commentsBorder,
                                                            inputMultiline: 'customScroll'
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                                <div>
                                    <Grid container spacing={16} classes={{ container: classes.formAction }}>
                                        <Grid item xs={4}></Grid>
                                        <Grid item xs={8} classes={{ item: classes.actionContainer }}>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                color="primary"
                                                classes={{
                                                    root: classes.actionButton,
                                                    disabled: classes.actionDisabled
                                                }}
                                                onClick={this.props.onClose}
                                                disabled={routeCreationInProgress}
                                            >
                                                Cancel
                                                </Button>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                disabled={!hasShipments || routeCreationInProgress}
                                                classes={{
                                                    root: `${classes.actionButton} ${routeCreationInProgress ? classes.activePrimaryButton : ''}`,
                                                    disabled: classes.actionDisabled
                                                }}
                                                type="submit">
                                                {this.state.routeCreationInProgress ? <CircularProgress size={16} color="inherit" /> : "Done"}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                        {this.state.routeCreationComplete ? (
                            <Feedback
                                {...this.state.routeCreationDetails}
                                undo={this.undoLasso}
                                isNew={isNewRoute}
                                close={this.props.onClose}
                                enqueueSnackbar={this.props.enqueueSnackbar}
                            />
                        ) : null}
                    </React.Fragment>
                }

            </Drawer>
        )
    }
}

export default compose(withStyles(styles), withSnackbar, withAppConfig)(LassoRoute);